import { render, staticRenderFns } from "./RelatedForum.vue?vue&type=template&id=b1dd67e6&scoped=true&"
import script from "./RelatedForum.vue?vue&type=script&lang=js&"
export * from "./RelatedForum.vue?vue&type=script&lang=js&"
import style0 from "./RelatedForum.vue?vue&type=style&index=0&id=b1dd67e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dd67e6",
  null
  
)

export default component.exports